

export const runsForFund = (runs, fundId) => Object.values(runs || {})
  .filter(it => it.fundId === fundId && it.status === 'Running')
